export default __webpack_public_path__ + "static/cell1-855e8822c0d2138fd67ac7484663d3b3.svg";